import React, { useState, useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchTenderingBandwidths } from "../../redux/actions/TenderingBandwidthActions";
import EnhancedTable from "../table/Table";
import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import TenderBandwidthForm from "./TenderBandwidthForm";
import Loader from "../../components/loader/Loader";
import { TenderingBandwidthModel } from "../../models/TenderingBandwidthModel";
import { isValidArr } from "../../utility/utils";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  // status: string;
};

const TenderBandwidthPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<TenderingBandwidthModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allData = useAppSelector(
    (state) => state.tenderingBandwidth.all_TenderingBandwidths
  );
  const isTenderBandwidthsFetching = useAppSelector(
    (state) => state.tenderingBandwidth.isTenderBandwidthsFetching
  );

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all tender bandwidths
  useEffect(() => {
    dispatch(fetchTenderingBandwidths());
  }, [dispatch]);

  // To prepare the root data
  useEffect(() => {
    setRootData(() =>
      allData.map((rec) => ({
        id: rec.tenderingBandwidthId,
        name: rec.name,
        description: rec.description,
        // status: rec.isActive ? "Active" : "Inactive",
      }))
    );
  }, [allData]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editRec = allData.find((rec) => rec.tenderingBandwidthId === id);
    setMode("edit");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allData) && isTenderBandwidthsFetching ? <Loader /> : null}
      <PageTitle
        title="Tender Bandwidths"
        btnText="Add Tender Bandwidth"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search Tender Bandwidths"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={
            mode === "add" ? "Create Tender Bandwidth" : "Edit Tender Bandwidth"
          }
          handleModalClose={handleModalClose}
        >
          <TenderBandwidthForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default TenderBandwidthPage;
